import { Routes, Route } from 'react-router-dom';
import AppContainer from './features/App/AppContainer';
import TrackingContainer from './features/Tracking/TrackingContainer';
import Login from './features/Auth/Login';
import CartBootstrap from './features/Cart/CartBootstrap';
import Cart from './features/Cart/Cart';
import AuthData from './features/Auth/AuthData';

function App() {
  return (
    <AppContainer>
      <Routes>
        <Route path="/initialize" element={<CartBootstrap />} />
        <Route path="/login" element={<Login />} />
        <Route path="/authdata" element={<AuthData />} />
        <Route path="/tracking" element={<TrackingContainer />} />
        <Route path="/cart/:cartId" element={<Cart />} />
      </Routes>
    </AppContainer>
  );
}

export default App;
